import React, { FC } from 'react';

import { GroupingSettings } from 'src/components/property-settings/sections/grouping-settings/GroupingSettings';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';

import { useSetProperty } from './utils/useSetProperty';

export const GroupingSectionModule: FC = () => {
	const {
		state: { draft, errors }
	} = usePropertySettings();
	const setProperty = useSetProperty();

	return (
		<GroupingSettings
			property={draft}
			setProperty={setProperty}
			propertyError={errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.GROUPING)}
		/>
	);
};
